import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '../app.service';

@Component({
  selector: 'app-dialog-edit-user',
  templateUrl: './dialog-edit-user.component.html',
  styleUrls: ['./dialog-edit-user.component.css']
})
export class DialogEditUserComponent implements OnInit {

  fg = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
    name: new FormControl(''),
    email: new FormControl('')
  })

  id: number

  isSupervisor = false

  wrongInput = false
  wrongInputReason = ""


  constructor(private serv: AppService, public dialogRef: MatDialogRef<DialogEditUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
    let u = this.data['user']
    
    this.id = +u['id']


    this.fg.get('username').setValue(u['username'])
    this.fg.get('name').setValue(u['name'])
    this.fg.get('email').setValue(u['email'])

    if (u['username'].toLowerCase() == "supervisor") {
      this.isSupervisor = true
    }

  }

  doSubmit() {
    let username = ""
    if (this.isSupervisor) {
      username = "supervisor"
    } else {
      username = this.fg.get('username').value
    }

    this.serv.adminEditUser(this.id, 
      username, 
      this.fg.get('password').value, 
      this.fg.get('name').value, 
      this.fg.get('email').value).subscribe(ret => {
        if (!ret['result']) {
          this.wrongInput = true
          this.wrongInputReason = ret['reason']
        } else {
          this.dialogRef.close(true)
        }
      })
  }
}
